import { Component } from "@angular/core";

@Component({
    selector: 'app-habilitacao-listagem',
    templateUrl: './habilitacao-listagem.component.html',
    styleUrls: ['./habilitacao-listagem.component.scss'],
    standalone: false
})
export class HabilitacaoListagemComponent {


}
